import { g } from '../ability';

export default function defineGetStartedAbilities(can) {
  can([g.UPGRADE], g.ACCOUNT);
  can([g.VIEW], g.BILL_SEARCH);
  can([g.VIEW], g.TRACK_BILL_CONFIRM);
  can([g.TRACK, g.TAG, g.VIEW], g.BILL);
  can([g.VIEW, g.EDIT], g.CUSTOM_FIELDS);
}
